import { useEffect } from "react"

const defaultTitle = "ChatBCC: Crash the Group Chat"
const defaultDescription =
  "Epic group chats hosted by your favorite podcasters, politicos, reality stars, athletes, comedians & more"

export const useDocumentTitleDescription = (
  title: string | null = defaultTitle,
  description: string | null = defaultDescription
) => {
  useEffect(() => {
    if (title != null) {
      document.title = title
      document.querySelector("meta[property='og:title']")?.setAttribute("content", title)
    }
    if (description != null) {
      document.querySelector("meta[name='description']")?.setAttribute("content", description)
      document
        .querySelector("meta[property='og:description']")
        ?.setAttribute("content", description)
    }
  }, [title, description])
}
